import { type FC } from "react";
import type { ErrorProps } from "../../../utils/errors/extract-zod-tree-error-props";
import { HeaderBar } from "../../generic/components/header-bar";
import { HeaderBarTitle } from "../../generic/components/header-bar-title";

export const FollowUpHeader: FC<{
  loading: boolean;
  programTitle?: string;
  title: string;
  setTitle: (title: string) => void;
  error: ErrorProps;
}> = ({ loading, programTitle, title, setTitle, error }) => {
  return (
    <HeaderBar navBurger>
      <HeaderBarTitle
        title={{
          type: "editable",
          value: title,
          onChange: setTitle,
          error,
        }}
        subtitle={programTitle}
        status={"draft"}
        loading={loading}
      />
    </HeaderBar>
  );
};
